import { Box, Tab, Tabs } from '@mui/material'
import { type FC, useMemo, useState } from 'react'
import { CalibrationAreaDialog } from '../calibrationAreaForm'
import { useLabelFormContext } from '../LabelFormContext'
import { AreaPanel } from './AreaPanel'
import { CalibrationAreaPanel } from './CalibrationAreaPanel'

const tabValues = {
  area: '検査箇所',
  calibrationArea: '位置補正基準',
} as const

export const AreaListTabs: FC = () => {
  const {
    formValues: { imageUrl, areas, calibrationAreas },
    errors,
    editingTarget,
    setEditingTarget,
    deleteArea,
    saveCalibrationArea,
    deleteCalibrationArea,
  } = useLabelFormContext()

  const [tabValue, setTabValue] = useState<keyof typeof tabValues>('area')

  const calibrationAreaDialogOpen = useMemo(
    () =>
      editingTarget.type === 'calibration-new' ||
      editingTarget.type === 'calibration-edit',
    [editingTarget],
  )
  return (
    <>
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        variant="fullWidth"
      >
        {Object.entries(tabValues).map(([key, label]) => (
          <Tab key={key} label={label} value={key} />
        ))}
      </Tabs>
      <Box role="tabpanel" hidden={tabValue !== 'area'}>
        <AreaPanel
          onClickExistingArea={area =>
            setEditingTarget({ type: 'area-edit', area })
          }
          areas={areas}
          canSave={errors.areas.length === 0}
          addNewArea={() => setEditingTarget({ type: 'area-new' })}
          errorMessages={errors.areas}
          deleteArea={deleteArea}
        />
      </Box>
      <Box role="tabpanel" hidden={tabValue !== 'calibrationArea'}>
        <CalibrationAreaPanel
          onClickExistingCalibrationArea={calibrationArea =>
            setEditingTarget({ type: 'calibration-edit', calibrationArea })
          }
          calibrationAreas={calibrationAreas}
          canSave={errors.calibrationAreas.length === 0}
          addNewCalibrationArea={() =>
            setEditingTarget({ type: 'calibration-new' })
          }
          errorMessages={errors.calibrationAreas}
          deleteCalibrationArea={deleteCalibrationArea}
        />
        {calibrationAreaDialogOpen && (
          <CalibrationAreaDialog
            open={true}
            onClose={() => setEditingTarget({ type: 'none' })}
            labelImageUrl={imageUrl}
            calibrationArea={
              editingTarget.type === 'calibration-edit'
                ? editingTarget.calibrationArea
                : undefined
            }
            saveCalibrationArea={saveCalibrationArea}
          />
        )}
      </Box>
    </>
  )
}
